<kt-base-modal [title]="'Pending'">
  <div modal-body>
    <kt-loader [showLoader]="loading()">
      <div style="height: calc(100vh - 200px);overflow: scroll;">
        <div class=" form-group" *ngIf="timesheetPendingTask.is_form_pending && formManagmentFeature">
          <div class="h5 text-center bg-light p-3 mb-3"> Pending Forms
          </div>
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Form Name</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let form of timesheetPendingTask.form_pending">
                <tr (click)="fillFormHandler(form)" class="cursor-pointer">
                  <td>{{form.task_name}}
                    <span class="text-danger form-required" *ngIf="form?.location_form_is_required">* (Form is required
                      to fill)</span>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>

          <div class="form-group">
            <kt-textarea [field]="formConstant.timesheet_form_pending_reason" [form]="commentFormGroup"></kt-textarea>
          </div>
        </div>
        <div class=" form-group" *ngIf="timesheetPendingTask.is_task_pending && taskFeature">
          <div class="h5 text-center bg-light p-3 mb-3"> Pending Tasks
          </div>
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Task Name</th>
                <th scope="col">Child</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let task of timesheetPendingTask.task_group_pending">
                <tr class="cursor-pointer" (click)="taskGroupClickHandler(task)">
                  <td>{{task.task_name}}</td>

                  <td>{{task.task_pending_childs}}</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
          <div class="form-group">
            <kt-textarea [field]="formConstant.timesheet_task_pending_reason" [form]="commentFormGroup"></kt-textarea>
          </div>
        </div>
        <!-- <div class=" form-group" *ngIf="timesheetPendingTask.is_loop_pending && loopFeature">
        <div class="h5 text-center bg-light p-3 mb-3"> Pending Loops
        </div>
  
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Loop Name</th>
              <th scope="col">Total</th>
              <th scope="col">Done</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let loop of timesheetPendingTask.loop_pending">
              <tr class="cursor-pointer" (click)="loopClickHandler(loop)">
                <td>{{loop.task_name}}</td>
                <td> {{loop.task_expected}}</td>
                <td>{{loop.task_actual}}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
        <div class="form-group">
          <kt-textarea [field]="formConstant.timesheet_loop_pending_reason" [form]="commentFormGroup"></kt-textarea>
        </div>
      </div> -->
        <div class=" form-group" *ngIf="timesheetPendingTask.is_patrol_pending && patrolFeature">
          <div class="h5 text-center bg-light p-3 mb-3"> Pending Patrol Scans
          </div>

          <table class="table">
            <thead>
              <tr>
                <th scope="col">Patrol Name</th>
                <th scope="col">Required</th>
                <th scope="col">On Time</th>
                <th scope="col">Total Scans</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="timesheetPendingTask.patrol_pending">
                <tr class="cursor-pointer" (click)="patrolClickHandler(timesheetPendingTask.patrol_pending)">
                  <td>{{timesheetPendingTask.patrol_pending?.patrol_name}}</td>
                  <td> {{timesheetPendingTask.patrol_pending?.patrol_expected_scan_count}}</td>
                  <td> {{timesheetPendingTask.patrol_pending?.patrol_on_time_scan_count}}</td>
                  <td>{{timesheetPendingTask.patrol_pending?.patrol_actual_scan_count}}</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
          <div class="form-group">
            <kt-textarea [field]="formConstant.timesheet_patrol_pending_reason" [form]="commentFormGroup"></kt-textarea>
          </div>
        </div>
      </div>

      <div class="kt-login__actions d-flex align-items-center justify-content-between mt-5 modal-footer">
        <kt-button [buttonConfig]="buttonConfig.CLOSE_BUTTON_CONFIG" (buttonClick)="activeModal.close()">
        </kt-button>
        <kt-button [buttonConfig]="buttonConfig.SAVE_BUTTON_CONFIG" (buttonClick)="submitClickHandler()">
        </kt-button>
      </div>
    </kt-loader>
  </div>
</kt-base-modal>